<template>
<el-main v-loading="loading"
        element-loading-text="Please wait.."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0.0, 0.0, 0.0, 0.4)">
    <div class="register">
        <el-form ref="form" :rules="rules" :model="form">
            <div>
                <h5>Name</h5>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item prop="firstName">
                            <el-input v-model="form.firstName" placeholder="eg. Jane"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item prop="lastName">
                            <el-input v-model="form.lastName" placeholder="eg. Doe"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div class="main-room">
                <h6>Lobby name</h6>
                <el-form-item prop="mainRoom" inline-message="true">
                    <el-input v-model="form.mainRoom" placeholder="eg. My Lobby Name"></el-input>
                </el-form-item>
                <p>The name of your lobby. (%, /, ? and # symbols are not allowed)</p>
            </div>
            <div>
                <h5>Email</h5>
                <el-form-item prop="email">
                    <el-input v-model="form.email" placeholder="eg. my@email.com"></el-input>
                </el-form-item>
            </div>
           <div>
                <h5>Business Name</h5>
                <el-form-item prop="businessName">
                    <el-input v-model="form.businessName" placeholder="eg. My Business Name"></el-input>
                </el-form-item>
            </div>
            <div>
                <h5>Number of Employees</h5>
                <el-form-item prop="noOfEmployees">
                    <el-input v-model="form.noOfEmployees" placeholder="eg. 150"></el-input>
                </el-form-item>
            </div>
            <div class="gst">
                <h6>
                    Are you based in, or have significant operations in
                    Australia
                </h6>
                <el-form-item prop="isAustralian">
                    <el-radio-group v-model="form.isAustralian">
                        <el-radio label="Yes"></el-radio>
                        <el-radio label="No"></el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <div class="terms-condition">
                <h6>Terms and conditions</h6>
                <el-form-item prop="termsAndCondition">
                    <el-checkbox v-model="form.termsAndCondition" name="type">I accept the <a href='https://www.berst.io/terms-and-conditions.html' target="_blank">terms and conditions</a> of use of Berst Pty Ltd
                    </el-checkbox>
                </el-form-item>
            </div>
            <el-form-item prop="recaptcha" style="margin-top:20px;">
                <vue-recaptcha ref="recaptcha" @verify="onCaptchaVerified" @expired="onCaptchaExpired" :sitekey="recaptchaSitekey" :loadRecaptchaScript="true"></vue-recaptcha>
            </el-form-item>
            <div style="text-align: center; margin: 30px 0 0 0;">
                <el-form-item>
                    <el-button type="primary" @click="submitForm('form')">Submit</el-button>
                </el-form-item>
            </div>
        </el-form>
    </div>
</el-main>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import axios from './client';
import { showMessage } from './utils';
import { mapState } from 'vuex';

export default {
    name: 'FreeTrail',
    components: {
        VueRecaptcha,
    },
    data() {
        const validateRoomName = async (rule, value, callback) => {
            let url = `api/rooms/${value}/exists`;
            const result = await axios.get(url);
            if (result.data && result.data.exists === false) {
                callback();
            } else {
                callback(new Error());
            }
        };

        return {
            isValidForm: false,
            recaptchaSitekey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
            form: {
                firstName: '',
                lastName: '',
                mainRoom: '',
                email: '',
                businessName: '',
                noOfEmployees: null,
                isAustralian: '',
                termsAndCondition: false,
                recaptcha: ''
            },
            rules: {
                firstName: [{
                        required: true,
                        message: 'Please enter first name',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: 'Please enter valid first name',
                        trigger: 'blur',
                        pattern: /^[^\s?#%/]*([^\s?#%/]+(\s?))*[^\s?#%/]$/
                    }
                ],
                lastName: [{
                        required: true,
                        message: 'Please enter last name',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: 'Please enter valid last name',
                        trigger: 'blur',
                        pattern: /^[^\s?#%/]*([^\s?#%/]+(\s?))*[^\s?#%/]$/
                    }
                ],
                mainRoom: [{
                        required: true,
                        message: 'Please enter lobby name',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: 'Please enter valid lobby name',
                        trigger: 'blur',
                        pattern: /^[^\s?#%/]*([^\s?#%/]+(\s?))*[^\s?#%/]$/
                    },
                    {
                        required: true,
                        message: 'Lobby name has already been claimed',
                        trigger: 'blur',
                        pattern: /^[^\s?#%/]*([^\s?#%/]+(\s?))*[^\s?#%/]$/,
                        validator: validateRoomName
                    }
                ],
                email: [{
                        required: true,
                        message: 'Please enter email',
                        trigger: 'blur'
                    },
                    {
                        type: 'email',
                        required: true,
                        message: 'Please enter valid email',
                        trigger: 'blur'
                    }
                ],
                businessName: [{
                        required: true,
                        message: 'Please enter business name',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: 'Please enter valid business name',
                        trigger: 'blur',
                        pattern: /^[^\s?#%/]*([^\s?#%/]+(\s?))*[^\s?#%/]$/
                    }
                ],
                noOfEmployees: [{
                        required: true,
                        message: 'Please enter number of employees',
                        trigger: 'blur'
                    },
                    {
                        required: true,
                        message: 'Please enter valid number of employees',
                        trigger: 'blur',
                        pattern: /^[1-9][0-9]*$/
                    }
                ],
                isAustralian: [{
                    required: true,
                    message: 'Please answer if you have Australian operations',
                    trigger: ['change', 'blur']
                }],
                termsAndCondition: [{
                    required: true,
                    message: 'Please accept terms and conditions',
                    trigger: 'change',
                    pattern: /true/
                }],
                recaptcha: [{
                    required: true,
                    message: 'Please verify the captcha',
                    trigger: ['change', 'blur']
                }]
            }
        };
    },
    methods: {
        submitForm(form) {
            if (
                this.$refs[form].validate(valid => {
                    if (valid && this.form.recaptcha) {
                        this.$store.commit('user/setAuthLoading', true);
                        this.$store.commit('updateRegistrationForm', {
                            formData: this.form
                        });
                        this.isValidForm = true;
                        this.registerUser()
                    } else {
                        return false;
                    }
                })
            );
        },

        onCaptchaVerified(recaptchaToken) {
            this.form.recaptcha = recaptchaToken;
            this.$refs.form.validateField('recaptcha');
        },

        onCaptchaExpired() {
            this.form.recaptcha = '';
            this.$refs.recaptcha.reset();
        },

        async registerUser() {
            if (this.isValidForm && this.form.recaptcha) {
                try {
                    const url = '/api/rooms/freeTrail/';
                    await axios.post(url, {
                        userData: this.form,
                    });
                    this.$message({
                        message: 'Congrats, Your registration is successful',
                        type: 'success'
                    });
                    this.$router.push({
                        path: '/registrationsuccess'
                    });
                } catch (error) {
                    this.$store.commit('user/setAuthLoading', false);
                    if(error.response.data.message === 'ROOM_OWNER_EXIST'){
                        showMessage('You are already a own owner. Try adding a new room from the dashboard','error')
                    }
                    else if (error && error.form) {
                        this.$message({
                            message: 'Unable to process your registration details',
                            type: 'error'
                        });
                        this.isValidForm = false;
                    } else {
                        this.$message({
                            message: 'Something went wrong please try again',
                            type: 'error'
                        });
                        this.isValidForm = false;
                    }
                }
            } else {
                return false;
            }
            this.$store.commit('user/setAuthLoading', false);

        }
    },
    computed: {
        ...mapState({
            loading: (state) => state.user.authLoading,
        }),
    },
};
</script>

<style scoped>
>>>.el-loading-mask{
    position: fixed;
}
.register {
    max-width: 700px;
    margin: 0 auto;
    text-align: left;
}

.el-main {
    height: 100%;
    overflow-y: scroll;
    margin-left: 0 !important;
}

.el-form-item__content {
    margin-left: 0 !important;
}

button.el-button--primary,
button.el-button--primary:hover {
    border: 1px solid #000000;
    background: #000000;
    padding: 8px;
}

p,
h5,
h6 {
    font-family: PP Telegraf, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
    margin: 10px 0;
}

p {
    font-family: PP Telegraf, sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 130%;
    margin: 10px 0;
}

.main-room,
.gst {
    margin: 20px 0px;
}

.main-room h6,
.gst h6,
.terms-condition h6 {
    font-family: PP Telegraf, sans-serif;
    font-size: 16px;
    line-height: 130%;
    text-decoration-color: rgb(221, 94, 57);
}

.main-room div,
.gst div {
    font-family: PP Telegraf, sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 130%;
    margin: 10px 0;
}

.el-form-item {
    margin-bottom: 0 !important;
}

.el-form-item.is-success .el-input__inner {
    height: 48px;
    border: 1px solid rgba(51, 51, 61, .2);
    border-radius: 10px;
    margin-bottom: 10px;
    border-color: #dcdfe6 !important
}

.el-form-item__error {
    position: relative !important;
}

.el-input__inner {
    height: 48px;
    border-radius: 10px;
    margin-bottom: 10px;
}
</style>
